(function () {
  var SHOW_EVERY_TIME = false;
  var HIDE_AFTER = 6900;
  var SAFETY_HIDE = 20000;
  var SETTLE_MS = 650;

  var LISTS = {
    wishlist: {
      event: 'wishlist:change',
      icons: '.tk-header__wishlist, .tk-header__mob-icon--wishlist',
      titleKey: 'wishlist_added_toast',
      hintKey: 'wishlist_hint_toast',
      linkKey: 'wishlist_view_toast',
      seenKey: 'tk-notify-wishlist'
    },
    compare: {
      event: 'compare:change',
      icons: '.tk-header__compare, .tk-header__mob-icon--compare',
      titleKey: 'compare_added_toast',
      hintKey: 'compare_hint_toast',
      linkKey: 'compare_view_toast',
      seenKey: 'tk-notify-compare'
    }
  };

  var el = null;
  var anchor = null;
  var hideTimer = null;
  var safetyTimer = null;
  var touchTimer = null;
  var settleUntil = 0;
  var shownAt = 0;
  var scrollAtShow = 0;
  var reducedMotion = false;
  try { reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function t(key, fallback) {
    return (window.tkI18n && window.tkI18n[key]) || fallback;
  }

  function visibleIcon(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getClientRects().length) return nodes[i];
    }
    return null;
  }

  function wasSeen(key) {
    try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; }
  }

  function markSeen(key) {
    try { sessionStorage.setItem(key, '1'); } catch (e) {}
  }

  function findItem(list, detail) {
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      if (detail.variantId && item.variantId) {
        if (String(item.variantId) === String(detail.variantId)) return item;
      } else if (String(item.id || item) === String(detail.productId)) {
        return item;
      }
    }
    return null;
  }

  function bump(icon) {
    if (!icon) return;
    icon.classList.remove('tk-list-bump');
    void icon.offsetWidth;
    icon.classList.add('tk-list-bump');
    setTimeout(function () { icon.classList.remove('tk-list-bump'); }, 1000);
  }

  function revealHeader() {
    var header = document.querySelector('.tk-header[sticky="scroll-up"]');
    if (header) header.setAttribute('data-sticky-state', 'active');
  }

  function build() {
    el = document.createElement('div');
    el.className = 'tk-list-notify';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<button type="button" class="tk-list-notify__close">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button>' +
      '<div class="tk-list-notify__head">' +
        '<span class="tk-list-notify__badge" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path class="tk-list-notify__check" d="M5 12.5l4.5 4.5L19 7.5"/></svg>' +
        '</span>' +
        '<span class="tk-list-notify__title"></span>' +
      '</div>' +
      '<div class="tk-list-notify__product">' +
        '<span class="tk-list-notify__thumb"><img alt="" width="54" height="54"></span>' +
        '<span class="tk-list-notify__name"></span>' +
      '</div>' +
      '<p class="tk-list-notify__hint"></p>' +
      '<a class="tk-list-notify__cta">' +
        '<span></span>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
      '</a>' +
      '<span class="tk-list-notify__bar" aria-hidden="true"></span>';

    var close = el.querySelector('.tk-list-notify__close');
    close.setAttribute('aria-label', t('close_label', 'Close'));
    close.addEventListener('click', hide);
    el.addEventListener('mouseenter', function () { el.classList.add('is-paused'); });
    el.addEventListener('mouseleave', function () { el.classList.remove('is-paused'); });
    el.addEventListener('touchstart', function () {
      el.classList.add('is-paused');
      clearTimeout(touchTimer);
      touchTimer = setTimeout(function () { el.classList.remove('is-paused'); }, 3500);
    }, { passive: true });
    el.addEventListener('animationend', function (e) {
      if (e.animationName === 'tkNotifyLife') hide();
    });
    document.body.appendChild(el);
  }

  function place() {
    if (!el || !anchor) return;
    var r = anchor.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var w = el.offsetWidth;
    var left = Math.round(cx - w + 40);
    left = Math.max(12, Math.min(left, window.innerWidth - w - 12));
    var top = Math.max(r.bottom, 0) + 12;
    el.style.left = left + 'px';
    el.style.top = Math.round(top) + 'px';
    el.style.setProperty('--tk-notify-caret', Math.round(cx - left) + 'px');
  }

  function settle() {
    place();
    if (performance.now() < settleUntil) requestAnimationFrame(settle);
  }

  function clearTimers() {
    clearTimeout(hideTimer);
    clearTimeout(safetyTimer);
  }

  function hide() {
    clearTimers();
    if (!el || !anchor) return;
    anchor = null;
    el.classList.remove('is-paused');
    el.classList.add('is-leaving');
    setTimeout(function () {
      if (anchor) return;
      el.classList.remove('is-visible', 'is-leaving');
    }, 260);
  }

  function fill(cfg, item, count) {
    var img = el.querySelector('.tk-list-notify__thumb img');
    var product = el.querySelector('.tk-list-notify__product');
    var src = item && item.image ? item.image : '';
    img.src = src;
    product.classList.toggle('no-image', !src);

    var name = el.querySelector('.tk-list-notify__name');
    name.textContent = (item && item.title) || '';
    if (item && item.variantTitle) {
      var variant = document.createElement('span');
      variant.className = 'tk-list-notify__variant';
      variant.textContent = item.variantTitle;
      name.appendChild(variant);
    }
    product.hidden = !name.textContent;

    el.querySelector('.tk-list-notify__title').textContent = t(cfg.titleKey, '');
    el.querySelector('.tk-list-notify__hint').textContent = t(cfg.hintKey, '');
    el.querySelector('.tk-list-notify__cta span').textContent = t(cfg.linkKey, '').replace('%COUNT%', count);
  }

  function show(cfg, icon, item, count) {
    if (!el) build();
    clearTimers();
    el.classList.remove('is-visible', 'is-leaving', 'is-paused');
    void el.offsetWidth;
    anchor = icon;
    fill(cfg, item, count);
    el.querySelector('.tk-list-notify__cta').href = icon.getAttribute('href') || '#';
    shownAt = performance.now();
    scrollAtShow = window.pageYOffset;
    settleUntil = shownAt + SETTLE_MS;
    place();
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
      settle();
    });
    if (reducedMotion) hideTimer = setTimeout(hide, HIDE_AFTER);
    safetyTimer = setTimeout(hide, SAFETY_HIDE);
  }

  function onChange(cfg, e) {
    var detail = e.detail || {};
    var list = detail.list || [];
    var item = findItem(list, detail);
    if (!item) return;
    requestAnimationFrame(function () {
      revealHeader();
      var icon = visibleIcon(cfg.icons);
      if (!icon) return;
      bump(icon);
      if (!SHOW_EVERY_TIME && wasSeen(cfg.seenKey)) return;
      markSeen(cfg.seenKey);
      show(cfg, icon, item, list.length);
    });
  }

  Object.keys(LISTS).forEach(function (name) {
    var cfg = LISTS[name];
    window.addEventListener(cfg.event, function (e) { onChange(cfg, e); });
  });

  window.addEventListener('scroll', function () {
    if (!anchor) return;
    if (performance.now() - shownAt < 300) return;
    if (Math.abs(window.pageYOffset - scrollAtShow) > 80) hide();
  }, { passive: true });

  window.addEventListener('resize', function () { if (anchor) place(); });

  document.addEventListener('click', function (e) {
    if (!anchor || !el || !e.isTrusted) return;
    if (el.contains(e.target)) return;
    hide();
  });
})();
